import { Component } from '@angular/core';
import { OrderPickViewParams } from '../order-pick-view.component';
import { StateService } from '@app/core/services/state.service';

@Component({
    selector: 'tt-order-pick-view-view',
    templateUrl: './order-pick-view-view.component.html',
    styleUrls: ['./order-pick-view-view.component.css'],
})
export class OrderPickViewViewComponent {
    public params: OrderPickViewParams;

    constructor(state: StateService) {
        this.params = state.getStateParams() as unknown as OrderPickViewParams;
    }
}
